import { FC } from "react";
import styles from "./sample-subheader.module.scss";

const SampleSubheaderGroup: FC = ({ children }) => (
  <div className={styles.subheader_group}>{children}</div>
);

export default SampleSubheaderGroup;
